import { request } from "@src/core/api/request";

export const downloadImportTemplate = async (url:string, fileName = "import_template") => {
    try {
      const blob = await request<Blob>({
        url,
        method: 'GET',
        responseType: 'blob',
      });
  
      // Create a blob URL and trigger download
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `${fileName}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download failed:', error);
      throw error;
    }
  };
  